module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/m4-ade367d44240a1ae5fd8d4dc1c90798f.svg";